import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { CLEARING_DOC_API } from "./apiRoutes";

interface UseGetClearingPropertyListProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClearingPropertyList = async (communityId: string) =>
  await axiosAuth.get(`${CLEARING_DOC_API(communityId)}/property-dropdown`);

const useGetClearingPropertyList = ({
  communityId,
  queryParams,
}: UseGetClearingPropertyListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["clearing-property-list", communityId],
    queryFn: () => getClearingPropertyList(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetClearingPropertyList;
